import { axiosClient } from '../../../../services/axiosInstance'

interface SessionResponse {
  isLoggedIn: boolean
}

export const getUserSession = async () => {
  const { data } = await axiosClient.get<SessionResponse>(
    `/api/account/session`
  )

  return data
}
